import { useSaveEditPracticeMutation } from "../services/practicesApi";

export const usePracticeApiSaveEditPracticeHook = () => {
  const [updatePractice] =
    useSaveEditPracticeMutation() || {};

  return { updatePractice };
};
